import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useContext,
  useRef,
} from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import './shoppingCart.css'
import Modal from 'react-bootstrap/Modal'
import PrincipalModal from '../Clientes/PrincipalModal'
import { VAContext } from '../../Context/VAContext'
import {
  PencilSquare,
  TrashFill,
  Cart,
  ExclamationTriangleFill,
} from 'react-bootstrap-icons'
import EliminarCliente from '../Clientes/EliminarCliente'
import AgregarCliente from '../Clientes/AgregarCliente'
import CartProduct from '../CartProduct'
import { useHistory } from 'react-router-dom'
import No from '../../Assets/Images/Login/no.svg'
import CrearCliente from '../../Views/Clientes/CrearCliente'
import {
  handleAddProductToCart,
  hasChangePriceApprove,
  marginTotal,
  toTitleCase,
} from '../../Utils/functions'
import { useDispatch, useSelector } from 'react-redux'
import {
  quitarDireccion,
  cotizacionRemoveClient,
  addAmounts,
  guardarTypeDocument,
  agregarCotizacion,
  mostrarDescuento,
  cotizacionPriceChangeApproval,
  addPriceList,
  cotizacionReStart,
  addSalesAgentFullName,
  agregarSucursal,
  agregarPDV,
  activeModalCustomer,
  removedDataClone,
  updatePlanIdLineas,
  updateTemporalFulfillmentPlan,
  agregarCliente,
} from '../../redux/actions/cotizacionActions.js'
import { priceListAddToCart, emptyCart } from '../../redux/actions/cartActions'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { animateScroll as scroll } from 'react-scroll'
import LightTooltip from '../LightTooltip'
import { t } from 'i18next'
import { fetchCustomerById } from 'redux/actions/clientsActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import CustomerInfo from 'Components/CustomerInfo'
import { ROUTES, VAPermissions, docHeaderStatusId } from 'Utils/constants'
import useValidatePermission from 'Hooks/useValidatePermission'
import { COTIZACION_REMOVE_CLIENT } from 'redux/types'
import MiniLoading from 'Components/MiniLoading'
import { useHasProductWithPriceUnderCost } from 'Components/CartProduct/hooks/useHasProductWithPriceUnderCost'
import ModalAlertCart from 'Components/ModalAlertCart/ModalAlertCart'
import CostMarginVisibility from 'Components/CostMarginVisibility/CostMarginVisibility'
import SummaryOrderCart from 'Components/SummaryOrderCart'
import ToolTipAmount from 'Components/ToolTipAmount/ToolTipAmount'
import { Formatter } from 'Utils/Formatter'
import { Box } from '@mui/material'
import { format } from 'date-fns'
import es from 'date-fns/locale/es'
import { CreditAccountsModal } from 'Components/CustomerInfo/components/CreditAccountsModal'

function ShoppingCart({
  handleMetodoEntrega,
  setClienteMetodoEntrega,
  setSelectedAddress,
  selectedAddress,
  promisedDate,
  setPromisedDate,
  direccion,
  setDireccion,
  editarCotizacion,
  edit,
  clone,
  productsRef,
}) {
  const [showModalEditClient, setShowModalEditClient] = useState(false)
  const [showCreditAccounts, setShowCreditAccounts] = useState(false)
  const [subtotal, setSubtotal] = useState(0)
  const [totalMargin, setTotalMargin] = useState(0)
  const dispatch = useDispatch()
  const history = useHistory()
  const [addressInfo, setAddressInfo] = useState(null)
  const [, setProductsChanged] = useState([])
  const { isCommercialSeller, hasPriceUnderCost } =
    useHasProductWithPriceUnderCost()
  // Check if user has create order role and permission
  const isUserAllowed = useValidatePermission(VAPermissions.createOrder)

  const seeMargenProd = useValidatePermission(VAPermissions.seeMargenProd)
  const canChangePrice = useValidatePermission(VAPermissions.priceOverrideAutho)
  const canChangePriceODV = useValidatePermission(
    VAPermissions.priceOverrideAuthODV
  )
  // BASE COTIZACIÓN
  const clienteFromCotizacion = useSelector(state => {
    const person = {
      CustomerName: state.cotizacion.QuoteHeader.CustomerNameDocument,
      EmailAddress:
        state.cotizacion.QuoteHeader.EmailAddress ||
        state.cotizacion.QuoteHeader.CustomerEmail,
      Telephone:
        state.cotizacion.QuoteHeader.Telephone_Number ||
        state.cotizacion.QuoteHeader.Cellphone_Number,
    }
    return person
  })
  // Fullfilment Deleted... show the address
  const [isFullFillmentDeleted, setIsFullFillmentDeleted] = useState(false)

  // State Cotizacion
  const client = useSelector(
    state => state.cotizacion?.QuoteHeader?.CustomerNameDocument
  )

  const clientEmail = useSelector(
    state =>
      state.cotizacion?.QuoteHeader?.EmailAddress ||
      state.cotizacion?.QuoteHeader?.CustomerEmail
  )

  const clientPhone = useSelector(
    state =>
      state.cotizacion?.QuoteHeader?.Telephone ||
      state.cotizacion?.QuoteHeader?.Telephone_Number
  )

  const address = useSelector(
    state => state.cotizacion?.QuoteHeader?.Address_Street
  )
  const cotizacion = useSelector(state => state.cotizacion?.QuoteHeader)
  const customerId = useSelector(
    state => state.cotizacion?.QuoteHeader?.CustomerId
  )

  const [isEditClienteContado, setIsEditClienteContado] = useState(false)
  const [warehousePickUp, setWarehousePickUp] = useState(null)

  // En caso de que se edite la cotización
  const lines = useSelector(state => state?.cotizacion?.QuoteHeader?.Lines)
  const [fulfillmentPlan, setFulfillmentPlan] = useState(null)

  // CLIENT TO COTIZACION
  const [clienteMetodoEntrega, setClienteCotizacion] = useState(null)

  // CLIENT VIEW STATE (CONTEXT API)
  const { showModalCreateClient, selectClient, clientSelected } =
    useContext(VAContext)

  // STATES CLIENT MODALS
  const [showModalClient, setShowModalClient] = useState(false)
  const [showModalDeleteClient, setShowModalDeleteClient] = useState(false)
  const [confirmDeleteClient, setConfirmDeleteClient] = useState(false)
  const [showModalAddClient, setShowModalAddClient] = useState(false)
  const [showModalCart, setShowModalCart] = useState(false)
  const [open, setOpen] = useState(false)
  const [modalInfoClient, setModalInfoClient] = useState(false)
  const [itbms, setItbms] = useState(0)
  const [quantity, setQuantiy] = useState(0)
  const [total, setTotal] = useState(0)
  const [totalOriginal, setTotalOriginal] = useState(null)

  // Error en generacion
  const [generacionError, setGeneracionError] = useState(false)
  const [totalWebQuoteError, setTotalWebQuoteError] = useState(false)

  // QUOTE LINES
  // const Lines = useSelector(state => state.cotizacion.QuoteHeader.Lines);
  const isCustomerUser = useSelector(state => state.login.isCustomer)
  const userId = useSelector(
    state => state?.login?.user?.CustomerInfo?.CustomerId
  )
  const userName = useSelector(
    state => state?.login?.user?.CustomerInfo?.FullName
  )

  const { isLoadingAllProducts } = useSelector(state => state?.cart)

  const cart = useSelector(state => state.cart.cart)

  const temporalFulfillmentPlan = useSelector(
    state => state.cotizacion?.temporalFulfillmentPlan
  )

  const hasNonServiceProducts = cart.some(product =>
    product.IsService !== undefined
      ? !product.IsService
      : product.Department !== 'Servicios'
  )

  // get company data to know if have default warehouse
  const company = useSelector(state => state.company)

  const channel = new BroadcastChannel('customer_display')

  const handlePriceChange = lines => {
    const approvedLines = lines.map(line => {
      const newLine = {
        ...line,
        AuthorizedPriceBy: userId,
        AuthorizedPriceByName: userName,
      }
      return newLine
    })

    dispatch(
      cotizacionPriceChangeApproval({
        Lines: approvedLines,
      })
    )
  }

  const handleShowModalClient = () => {
    setShowModalClient(!showModalClient)
    dispatch(activeModalCustomer(true))
    showModalCreateClient(0)
  }

  const clientToEdit = CustomerId => {
    setShowModalClient(true)
    dispatch(activeModalCustomer(false))
    showModalCreateClient(0)
  }

  const handleModalDelete = () => {
    setClienteMetodoEntrega(false)
    setShowModalDeleteClient(false)
    setFulfillmentPlan(null)
    setIsFullFillmentDeleted(true)
    setWarehousePickUp(false)
    setSelectedAddress(null)
    setDireccion(null)
    setAddressInfo(null)
    setConfirmDeleteClient(true)
    dispatch({ type: COTIZACION_REMOVE_CLIENT })
  }

  const handleModalAdd = () => {
    setShowModalAddClient(!showModalAddClient)
  }

  const showMetodoEntrega = () => {
    setClienteMetodoEntrega(true)
    handleMetodoEntrega()
  }

  const handleGeneracion = () => {
    if (cart < 1) {
      setGeneracionError(true)
    }
  }
  const createQuote = useValidatePermission(VAPermissions.createQuote)
  useEffect(() => {
    if (confirmDeleteClient) {
      dispatch(cotizacionRemoveClient())
      dispatch(quitarDireccion())
      dispatch(addPriceList(undefined))
      setClienteCotizacion(null)
      setConfirmDeleteClient(false)
      if (cart.length) {
        dispatch(emptyCart())

        dispatch(priceListAddToCart(cart))
      }
    }
  }, [confirmDeleteClient])

  useEffect(() => {
    if (!showModalClient && clientSelected.customerID !== '') {
      selectClient('', false, false)
    } else {
      setClienteMetodoEntrega(false)
    }
  }, [showModalClient])

  useEffect(() => {
    if (subtotal > 0) {
      dispatch(
        addAmounts({
          Quantity: parseFloat(quantity),
          Amount: Formatter.Money(subtotal),
          Tax: Formatter.Money(itbms),
          AmountWithTax: Formatter.Money(subtotal + itbms),
        })
      )
    }
  }, [subtotal])

  const calculateAmounts = () => {
    let totalTax = 0
    let totalPrice = 0
    let totalCost = 0
    let Quantity = 0
    let cost = 0

    cart.forEach(item => {
      const additionalDiscount = item.VisitDiscountAmount || 0
      const subtotalLine = Number(
        Formatter.Money(item.Price * item.Quantity - additionalDiscount, {
          withFormat: false,
          rounded: true,
          decimalPrecision: 2,
        })
      )

      const taxLine = subtotalLine * item.TaxCategoryValue

      totalTax += taxLine
      totalPrice += subtotalLine
      cost = item.Cost || item.AvgCost || 0.0
      totalCost += cost * item.Quantity
      Quantity = parseFloat(Quantity) + parseFloat(item?.Quantity)
    })

    totalPrice = Number(
      Formatter.Money(totalPrice, {
        decimalPrecision: 2,
        withFormat: false,
      })
    )
    setQuantiy(Quantity)
    const newItbms = Number(
      Formatter.Money(totalTax, {
        withFormat: false,
      })
    )

    const newTotal = Number(totalPrice) + Number(totalTax)
    setItbms(newItbms)
    setTotal(newTotal)
    setSubtotal(totalPrice)

    channel.postMessage({
      productCart: cart,
      subtotal: totalPrice,
      itbms: newItbms,
      total: newTotal,
    })

    const totalMargin = marginTotal(totalCost, totalPrice)

    setTotalMargin(totalMargin)
  }

  useEffect(() => {
    const productsWithPriceChange = lines.filter(
      line =>
        line?.NegotiatedReasonId &&
        line?.NegotiatedReasonId !== null &&
        line.NegotiatedReasonId !== ''
    )
    // remove approved products
    const productsWithPriceChangeFiltered = productsWithPriceChange.filter(
      line => line.AuthorizedPriceByName === null
    )
    setProductsChanged(productsWithPriceChangeFiltered)

    calculateAmounts()
  }, [cart])

  const addProduct = async product => {
    await handleAddProductToCart({
      product,
      cart,
      dispatch,
      customerId,
    })
  }

  useEffect(async () => {
    channel.onmessage = event => {
      if (event.data.isAddedProduct) {
        addProduct(event.data.productCart)
        calculateAmounts()
      }

      if (event.data.windowClose) window.close()
    }
  }, [])

  const activateEditAddress = () => {
    setFulfillmentPlan(lines?.[0]?.FulfillmentPlanId)
    const isEdition = window.location.pathname.includes('editar_cotizacion')
    const isClone = window.location.pathname.includes('clonar_cotizacion')
    const withAddressValidation =
      isEdition || isClone
        ? cotizacion?.QuoteAddressId ||
          cotizacion?.AddressId ||
          cotizacion?.Address_AddressId
        : false

    if (withAddressValidation) {
      const isWebDocument = cotizacion?.Origin === 'AB'
      setDireccion(true)
      setWarehousePickUp(true)
      setAddressInfo({
        Address_CountryName: cotizacion.Address_CountryName,
        Address_ProvinceName: cotizacion.Address_ProvinceName,
        Address_Street: isWebDocument
          ? cotizacion.Address_AddressDetail
          : cotizacion.Address_Street,
        Address_DistrictName: cotizacion.Address_DistrictName,
        Address_TownshipName: cotizacion.Address_TownshipName,
        Address_AddressDetail: isWebDocument
          ? cotizacion?.Address_AddressName || cotizacion.Address_Street
          : cotizacion.Address_AddressName,
      })
    } else {
      setDireccion(false)
      setWarehousePickUp(true)
      const warehouse = {
        Description:
          cotizacion?.Lines?.[0]?.WarehouseDescription ||
          cotizacion.WarehouseDescription,
        Code: cotizacion?.Lines?.[0]?.WarehouseCode,
        WarehouseId: cotizacion?.Lines?.[0]?.WarehouseId,
      }

      setAddressInfo(warehouse)
    }
  }
  const executedS = useRef(false)
  const fetchCustomerDetail = async customerId => {
    const dataCustomer = await dispatch(fetchCustomerById(customerId, true))
    if (dataCustomer) {
      setClienteCotizacion(dataCustomer)
    }
  }

  const handleSuccessUpdateClient = async () => {
    if (customerId) {
      const dataCustomer = await dispatch(fetchCustomerById(customerId, true))
      if (dataCustomer) {
        const customerInfo = dataCustomer?.CustomerInfo
        const priceListId =
          customerInfo?.PriceList?.find(price => price?.DefaultList)
            ?.PriceListId || customerInfo?.PriceList?.[0]?.PriceListId
        setClienteCotizacion({
          ...dataCustomer,
          CustomerID: customerInfo?.CustomerId,
        })
        dispatch(
          agregarCliente({
            id: customerInfo?.CustomerId,
            customerName: customerInfo?.FullName || customerInfo?.LegalName,
            externalCode: customerInfo?.SystemCode,
            customerType: customerInfo?.CustomerTypeId,
            customerEmail: customerInfo?.Email,
            priceListId,
            customerPhone: customerInfo?.Telephone,
          })
        )
      }
    }
  }

  // VALIDACIÓN para cotizaciones
  const onProductPriceChange = () => {
    // VALIDACIÓN: Si tiene permiso para cambiar precios en cotizaciones, NO bloquea
    if (canChangePrice) {
      return false
    }
    // VALIDACIÓN: Si es vendedor comercial y NO tiene precio bajo costo, NO bloquea
    if (!hasPriceUnderCost && isCommercialSeller) {
      return false
    }
    // VALIDACIÓN: Si hay productos con precio bajo costo, SÍ bloquea
    return hasChangePriceApprove(cart)
  }

  // VALIDACIÓN para órdenes de venta (ODV)
  const onProductPriceChangeODV = () => {
    // VALIDACIÓN: Si tiene permiso para cambiar precios en ODV, NO bloquea
    if (canChangePriceODV) {
      return false
    }
    // VALIDACIÓN: Si es vendedor comercial y NO tiene precio bajo costo, NO bloquea
    if (!hasPriceUnderCost && isCommercialSeller) {
      return false
    }
    // VALIDACIÓN: Si hay productos con precio bajo costo, SÍ bloquea
    return hasChangePriceApprove(cart)
  }

  useEffect(() => {
    if (edit || clone) {
      if (cotizacion?.Payments?.length > 0) {
        const total = cotizacion.Payments.reduce((acc, pago) => {
          const amount = parseFloat(pago.PaymentAmount) || 0
          return acc + amount
        }, 0)
        setTotalOriginal(total)
      } else {
        setTotalOriginal(0)
      }
      setIsEditClienteContado(
        cotizacion?.CustomerId === null && cotizacion?.CustomerNameDocument
      )

      if (!isFullFillmentDeleted) {
        activateEditAddress()
        if (
          cotizacion?.CustomerId &&
          direccion !== null &&
          warehousePickUp !== null &&
          !executedS.current
        ) {
          executedS.current = true
          fetchCustomerDetail(customerId)
        }
      }
    }
  }, [cotizacion])

  useEffect(() => {
    setAddressInfo(selectedAddress ?? null)

    // Actualizar warehousePickUp basándose en el tipo de dirección
    if (selectedAddress) {
      const isBranch =
        selectedAddress?.WarehouseId || selectedAddress?.WarehouseDescription
      const isHome =
        selectedAddress?.AddressInfo || selectedAddress?.Address_AddressId
      if (isBranch) {
        setWarehousePickUp(true)
        setDireccion(false)
      } else if (isHome) {
        setWarehousePickUp(true)
        setDireccion(true)
      }
    } else {
      // Si no hay dirección, limpiar el estado
      setWarehousePickUp(false)
    }
  }, [selectedAddress])

  // Limpieza del estado cuando llegan updates asíncronos tardíos
  // Usamos useLayoutEffect para evitar parpadeo visual
  const quoteHeaderId = cotizacion?.QuoteHeaderId
  const hasExistingDocumentData =
    quoteHeaderId && quoteHeaderId !== '00000000-0000-0000-0000-000000000000'

  useLayoutEffect(() => {
    if (!edit && !clone && hasExistingDocumentData && client) {
      dispatch(cotizacionReStart())
      dispatch(cotizacionRemoveClient())
      dispatch(quitarDireccion())
    }
  }, [edit, clone, hasExistingDocumentData, client])

  // Para clones: ejecutar removedDataClone al montar
  useEffect(() => {
    if (clone) {
      dispatch(removedDataClone())
    }
  }, [clone])

  useEffect(() => {
    const lineWithFulfillmentPlan =
      (lines || []).filter(item => item.FulfillmentPlanDescription)?.[0] ?? null

    if (lineWithFulfillmentPlan) {
      dispatch(
        updateTemporalFulfillmentPlan({
          fulfillmentPlanId: lineWithFulfillmentPlan.FulfillmentPlanId,
          fulfillmentPlanDescription:
            lineWithFulfillmentPlan.FulfillmentPlanDescription,
        })
      )
    }
  }, [lines])

  const hasProdWithNoCost = cart.some(
    item => !item.IsService && item.Cost === 0
  )

  const cotizationType = [
    {
      id: '',
      name: t('PRODUCTS_T.COTIZATION_TYPE.CANCEL_NAME'),
      value: t('PRODUCTS_T.COTIZATION_TYPE.CANCEL_VALUE'),
      valueState: 'CANCEL',
      disabled: false,
      className: 'products-cart-button-tooltip',
    },
    {
      id: docHeaderStatusId.draft,
      name: t('PRODUCTS_T.COTIZATION_TYPE.DRAFT_NAME'),
      value: t('PRODUCTS_T.COTIZATION_TYPE.DRAFT_VALUE'),
      valueState: 'DRAFT',
      disabled: cotizacion.DocHeaderStatusAction === 'OPEN',
      className: 'products-cart-button-tooltip',
    },
    {
      id: docHeaderStatusId.open,
      name: t('PRODUCTS_T.COTIZATION_TYPE.OPEN_NAME'),
      value: t('PRODUCTS_T.COTIZATION_TYPE.OPEN_VALUE'),
      valueState: 'OPEN',
      disabled:
        isCustomerUser ||
        onProductPriceChange() ||
        !createQuote ||
        hasProdWithNoCost,
      className: 'products-cart-button-tooltip',
    },
    {
      id: 'SALES_ORDER',
      name: t('PRODUCTS_T.COTIZATION_TYPE.SALES_ORDER_NAME'),
      value: '',
      valueState: '',
      disabled:
        edit ||
        isCustomerUser ||
        onProductPriceChangeODV() ||
        !isUserAllowed ||
        hasProdWithNoCost,
      className: 'products-cart-button-tooltip',
    },
  ]

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const scrollToTop = () => {
    scroll.scrollToTop({
      delay: 0,
      smooth: 'linear',
      duration: 1,
    })
  }
  const resetAddressStatus = () => {
    setIsFullFillmentDeleted(true)
    setSelectedAddress(null)
    setDireccion(null)
    setAddressInfo(null)
    setWarehousePickUp(false)
    dispatch(quitarDireccion())
    setFulfillmentPlan(null)
    handleDeleteDeliveryMethod()
  }
  // set default Warehouse to quotation
  const setDefaultWarehouseToQuotation = () => {
    const warehouse = {
      WarehouseId: company?.WarehouseId,
      WarehouseDescription: company?.WarehouseDescription,
      WarehouseAddress: company?.WarehouseAddress,
      WarehouseCode: company?.WarehouseCode,
      WarehouseName: company?.WarehouseName,
      Description: company?.WarehouseDescription,
    }
    dispatch(agregarSucursal(warehouse))
    setDireccion(false)
    setSelectedAddress(warehouse)
    setWarehousePickUp(true)
  }

  const handleDeleteDeliveryMethod = () => {
    setSelectedAddress(null)
    setDireccion(null)
    setAddressInfo(null)
    setWarehousePickUp(false)
    dispatch(quitarDireccion())
    setFulfillmentPlan(null)
    setIsFullFillmentDeleted(true)
    setPromisedDate(null)
    setClienteMetodoEntrega(false)
  }
  return (
    <Container
      className="container-shopping-cart"
      data-testid="container-shopping-cart">
      <Row>
        <Col className="productos-cotizacion-right">
          <div className="products-cart" data-testid="container-products-cart">
            {isLoadingAllProducts ? (
              <MiniLoading />
            ) : cart?.length > 0 ? (
              <div
                className="product-cart-products-display"
                data-testid="container-cart-products-display">
                <div
                  className="product-cart-full-summary"
                  data-testid="container-cart-summary">
                  <h2>{`${t('PRODUCTS_T.PRODUCT_RESUME_TITLE')} (${
                    cart.length
                  })`}</h2>
                  {cart.length >= 5 && (
                    <p
                      className="product-cart-see-full-summary"
                      data-testid="btn-view-full-summary"
                      onClick={() => {
                        setShowModalCart(true)
                      }}>
                      {t('PRODUCTS_T.VIEW_RESUME')}
                    </p>
                  )}
                </div>
                <hr />
                <Row>
                  <div className="product-cart-products">
                    <div
                      className="product-cart-products-inner"
                      data-testid="container-cart-products-list">
                      {cart?.map((product, index) => {
                        return (
                          <CartProduct
                            product={product}
                            productsRef={productsRef}
                            setProductChangeValidation={value => {
                              dispatch({
                                type: 'IS_PRICE_CHANGED',
                                payload: { index, value },
                              })
                            }}
                            key={
                              product.LineNum ??
                              `${product.ProductId}-${product.IsExtendedWarranty}`
                            }
                          />
                        )
                      })}
                    </div>
                    <div
                      className="product-cart-totals"
                      data-testid="container-cart-totals">
                      <div className="product-cart-total-text">
                        <p>{t('PRODUCTS_T.SUBTOTAL_LABEL')}</p>
                        <p>{t('PRODUCTS_T.ITBMS_LABEL')}</p>
                        <p>
                          <strong>{t('PRODUCTS_T.TOTAL_LABEL')}</strong>
                        </p>
                        {seeMargenProd ? (
                          <p>{t('PRODUCTS_T.TOTAL_MARGIN_LABEL')}</p>
                        ) : null}
                      </div>
                      <div
                        className="product-cart-total-numbers"
                        data-testid="container-cart-total-numbers">
                        <p
                          style={{ marginRight: 17 }}
                          data-testid="cart-subtotal-value">
                          {'$' + Formatter.Money(subtotal)}
                        </p>
                        <ToolTipAmount amount={itbms} />
                        <ToolTipAmount amount={total} />
                        <div>
                          {seeMargenProd && (
                            <CostMarginVisibility
                              seeMargenProd={seeMargenProd}
                              simple
                              isMargin
                              margin={totalMargin.toFixed(2)}
                              secondaryColor
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Row>
              </div>
            ) : (
              <div
                className="product-cart-inner"
                data-testid="container-empty-cart-message">
                <h2>{t('PRODUCTS_T.ADD_PRODUCTS_LABEL')}</h2>
                <Cart style={{ fontSize: '20px' }} />
              </div>
            )}
          </div>

          <div
            className={
              clienteMetodoEntrega !== null || isEditClienteContado
                ? 'customer-cotizacion-visible'
                : 'customer-cotizacion-none'
            }
            data-testid="container-customer-info">
            <div className="customer-cart" data-testid="card__customer-cart">
              <div
                className="customer-cart-items"
                data-testid="container-customer-details">
                {!edit || !clone ? (
                  <>
                    <h4>Cliente: {client}</h4>
                    <h4>
                      {t('PRODUCTS_T.EMAIL_LABEL')}{' '}
                      {clientEmail || t('PRODUCTS_T.NO_INFORMATION_LABEL')}
                    </h4>
                    <h4>
                      Teléfono:{' '}
                      {clientPhone || t('PRODUCTS_T.NO_INFORMATION_LABEL')}
                    </h4>
                  </>
                ) : (
                  edit ||
                  (clone && (
                    <>
                      <h4>Cliente: {clienteFromCotizacion?.CustomerName}</h4>
                      <h4>
                        {t('PRODUCTS_T.EMAIL_LABEL')}{' '}
                        {clienteFromCotizacion?.EmailAddress ||
                          t('PRODUCTS_T.NO_INFORMATION_LABEL')}
                      </h4>
                      <h4>
                        Teléfono:{' '}
                        {clienteFromCotizacion?.Telephone ||
                          t('PRODUCTS_T.NO_INFORMATION_LABEL')}
                      </h4>
                    </>
                  ))
                )}
              </div>
              <div className="icons">
                <div
                  data-testid="btn-edit-client"
                  onClick={() => {
                    clientToEdit(clienteMetodoEntrega?.CustomerID)
                  }}>
                  <PencilSquare />
                </div>
                {clienteMetodoEntrega?.CustomerID && (
                  <div
                    data-testid="btn-view-client"
                    onClick={() => {
                      setModalInfoClient(true)
                    }}>
                    <FontAwesomeIcon
                      icon={faEye}
                      style={{ color: '#11D29E' }}
                    />
                  </div>
                )}
                <div
                  data-testid="btn-delete-client"
                  onClick={() => setShowModalDeleteClient(true)}>
                  <TrashFill style={{ color: '#fb5c3c' }} />
                </div>
              </div>
            </div>
          </div>
          {(addressInfo || fulfillmentPlan) && ( // && address !== null
            <div
              className="shopping-address-display"
              data-testid="container-address-display"
              style={{
                display:
                  (clienteMetodoEntrega !== null && direccion !== null) ||
                  isEditClienteContado
                    ? 'flex'
                    : 'none',
              }}>
              <Box display="flex" flexDirection="column">
                {addressInfo?.WarehouseId ||
                (addressInfo?.WarehouseDescription &&
                  !cotizacion?.QuoteAddressId) ? (
                  <h2>
                    <span className="address-bold">
                      {t('PRODUCTS_T.RECEIVE_ON_SITE_LABEL')}
                    </span>
                    {' ' +
                      toTitleCase(
                        addressInfo?.WarehouseDescription ||
                          addressInfo?.WarehouseDescription ||
                          addressInfo?.Description
                      )}
                  </h2>
                ) : addressInfo ? (
                  <div>
                    <h2 className="complete-address">
                      <span className="address-bold">
                        {t('PRODUCTS_T.COUNTRY_LABEL')}{' '}
                      </span>
                      {addressInfo?.AddressInfo?.Country?.Name ||
                        addressInfo?.Address_CountryName ||
                        addressInfo?.AddressInfo?.Address_CountryName ||
                        addressInfo?.AddressInfo?.CountryName ||
                        t('PRODUCTS_T.NO_INFORMATION_LABEL')}
                    </h2>
                    <h2 className="complete-address">
                      <span className="address-bold">
                        {t('PRODUCTS_T.PROVINCE_NAME')}{' '}
                      </span>
                      {addressInfo?.AddressInfo?.Province?.Name ||
                        addressInfo?.AddressInfo?.ProvinceName ||
                        addressInfo?.AddressInfo?.Address_ProvinceName ||
                        addressInfo?.Address_ProvinceName ||
                        t('PRODUCTS_T.NO_INFORMATION_LABEL')}
                    </h2>
                    <h2 className="complete-address">
                      <span className="address-bold">
                        {t('PRODUCTS_T.DISTRICT_LABEL')}{' '}
                      </span>
                      {addressInfo?.AddressInfo?.District?.Name ||
                        addressInfo?.AddressInfo?.DistrictName ||
                        addressInfo?.AddressInfo?.Address_DistrictName ||
                        addressInfo?.Address_DistrictName ||
                        t('PRODUCTS_T.NO_INFORMATION_LABEL')}
                    </h2>
                    <h2 className="complete-address">
                      <span className="address-bold">
                        {t('PRODUCTS_T.STATE_LABEL')}{' '}
                      </span>
                      {addressInfo?.AddressInfo?.Township?.Name ||
                        addressInfo?.AddressInfo?.TownshipName ||
                        addressInfo?.AddressInfo?.Address_TownshipName ||
                        addressInfo?.Address_TownshipName ||
                        t('PRODUCTS_T.NO_INFORMATION_LABEL')}
                    </h2>
                    <h2 className="complete-address">
                      <span className="address-bold">
                        {t('PRODUCTS_T.STREET_LABEL')}{' '}
                      </span>
                      {addressInfo?.AddressInfo?.Street ||
                        addressInfo?.AddressInfo?.Street ||
                        addressInfo?.AddressInfo?.Address_Street ||
                        addressInfo?.Address_Street ||
                        t('PRODUCTS_T.NO_INFORMATION_LABEL')}
                    </h2>
                    <h2 className="complete-address">
                      <span className="address-bold">
                        {t('PRODUCTS_T.ALIAS_LABEL')}{' '}
                      </span>
                      {addressInfo?.AddressInfo?.Name ||
                        addressInfo?.AddressInfo?.AddressDetail ||
                        addressInfo?.AddressInfo?.Alias ||
                        addressInfo?.AddressInfo?.Address_AddressDetail ||
                        addressInfo?.Address_AddressDetail ||
                        t('PRODUCTS_T.NO_INFORMATION_LABEL')}
                    </h2>
                  </div>
                ) : null}
                {promisedDate && (
                  <h2 className="complete-address">
                    <span className="address-bold">{'Retiro/Entrega: '}</span>
                    {format(new Date(promisedDate), "d 'de' MMMM 'de' yyyy", {
                      locale: es,
                    })}
                  </h2>
                )}
                {temporalFulfillmentPlan && hasNonServiceProducts && (
                  <h2 className="complete-address">
                    <span className="address-bold">{'Plan de Entrega: '}</span>
                    {temporalFulfillmentPlan.fulfillmentPlanDescription}
                  </h2>
                )}
              </Box>
              <div className="icons">
                <div
                  data-testid="btn-edit-address"
                  onClick={() => editarCotizacion()}>
                  <PencilSquare />
                </div>
                <div
                  data-testid="btn-delete-address"
                  onClick={handleDeleteDeliveryMethod}>
                  <TrashFill />
                </div>
              </div>
            </div>
          )}
          <Row
            style={{
              marginTop: '10px',
            }}>
            <Col sm={4} md={4} lg={4} xl={4}>
              <button
                className="products-cart-button"
                data-testid="btn-select-or-create-client"
                onClick={handleShowModalClient}
                disabled={!!client}>
                <div className="products-cart-button-text">
                  {t('PRODUCTS_T.SELECT_OR_CREATE_CLIENT_LABEL')}{' '}
                </div>
              </button>
            </Col>
            <Col sm={4} md={4} lg={4} xl={4}>
              <button
                className="products-cart-button"
                data-testid="btn-select-delivery-method"
                onClick={() => {
                  showMetodoEntrega()
                  scrollToTop()
                }}
                disabled={!client}>
                <div className="products-cart-button-text">
                  {t('PRODUCTS_T.SELECT_DELIVERY_METHOD_LABEL')}{' '}
                </div>
              </button>
            </Col>
            <Col sm={4} md={4} lg={4} xl={4}>
              <ClickAwayListener onClickAway={() => handleTooltipClose()}>
                <>
                  <LightTooltip
                    title={cotizationType
                      .filter(item => !item.disabled)
                      .map((item, index) => {
                        if (
                          (!isUserAllowed && item.id === 'SALES_ORDER') ||
                          (!createQuote && item.id === docHeaderStatusId.open)
                        ) {
                          return null
                        }

                        return (
                          // <>
                          <button
                            disabled={item.disabled}
                            key={index}
                            className={item.className}
                            data-testid={`btn-type-cotization-${item.valueState?.toLowerCase()}`}
                            onClick={() => {
                              if (cart.length === 0) {
                                handleGeneracion()
                                return
                              }

                              const isSalesOrderWeb =
                                cotizacion?.Origin === 'AB'
                              if (isSalesOrderWeb && total > totalOriginal) {
                                setTotalWebQuoteError(true)
                                return
                              }

                              if (!item.id) {
                                setOpen(false)
                                return
                              }

                              dispatch(
                                guardarTypeDocument({
                                  HeaderStatusId: item.id,
                                  DocHeaderStatusDescription: item.value,
                                  DocHeaderStatusAction: item.valueState,
                                })
                              )

                              const modifiedLines = cart.map(element => ({
                                ...element,
                                Quantity:
                                  element.Quantity === '' ||
                                  element.Quantity === null ||
                                  element.Quantity === undefined ||
                                  Number.isNaN(
                                    Number.parseFloat(element.Quantity)
                                  ) ||
                                  Number.parseFloat(element.Quantity) <= 0
                                    ? 1
                                    : element.Quantity,
                                WarehouseId: addressInfo?.WarehouseId,
                                WarehouseDescription: addressInfo?.Description,
                                WarehouseAddress: addressInfo?.WarehouseAddress,
                                WarehouseCode: addressInfo?.Code,
                              }))

                              if (!edit) {
                                dispatch(addSalesAgentFullName(userName))
                              }

                              dispatch(agregarPDV(modifiedLines))

                              dispatch(
                                agregarCotizacion({
                                  Lines: modifiedLines,
                                  PromisedDate: promisedDate,
                                })
                              )

                              dispatch(
                                updatePlanIdLineas({
                                  cart: modifiedLines,
                                  fulfillmentPlanId: temporalFulfillmentPlan
                                    ? temporalFulfillmentPlan.fulfillmentPlanId
                                    : null,
                                  fulfillmentPlanDescription:
                                    temporalFulfillmentPlan
                                      ? temporalFulfillmentPlan.fulfillmentPlanDescription
                                      : null,
                                })
                              )

                              if (
                                canChangePrice &&
                                cotizacion.NegotiatedReasonId
                              ) {
                                if (isCommercialSeller) {
                                  if (!hasPriceUnderCost) {
                                    handlePriceChange(modifiedLines)
                                  }
                                } else {
                                  handlePriceChange(modifiedLines)
                                }
                              }

                              dispatch(mostrarDescuento(true))

                              if (item.id === 'SALES_ORDER') {
                                history.push('/generar_cotizacion/sales_order')
                              } else {
                                history.push(ROUTES.generateQuote)
                              }
                            }}>
                            {item.name}
                          </button>
                          // </>
                        )
                      })}
                    PopperProps={{
                      disablePortal: true,
                    }}
                    placement="top"
                    arrow={true}
                    open={open}
                    onClose={handleTooltipClose}
                    disableFocusListener
                    disableTouchListener>
                    <button
                      className="products-cart-button"
                      data-testid="btn-create-quotation"
                      onClick={() => {
                        setOpen(true)
                      }}
                      disabled={
                        !!(
                          !client ||
                          (!addressInfo &&
                            address === null &&
                            !warehousePickUp) ||
                          (hasNonServiceProducts && !temporalFulfillmentPlan)
                        )
                      }>
                      <div className="products-cart-button-text">
                        {edit
                          ? t('PRODUCTS_T.UPDATE_QUOTATION')
                          : t('PRODUCTS_T.CREATE_QUOTATION_LABEL')}
                      </div>
                    </button>
                  </LightTooltip>
                </>
              </ClickAwayListener>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Recordatorio para agregar productos */}
      <Modal
        show={generacionError}
        data-testid="modal-empty-cart-error"
        centered
        cla>
        <div className="box-generacion">
          <div className="box-generacion-header">
            <img
              src={No}
              alt="cerrar-modal"
              onClick={() => setGeneracionError(false)}
            />
          </div>
          <div className="box-generacion-body">
            <Cart style={{ fontSize: '20px' }} />
            <p>{t('PRODUCTS_T.ADD_PRODUCTS_CREATE_QUOTATION')}</p>
          </div>
        </div>
      </Modal>
      <Modal
        show={totalWebQuoteError}
        data-testid="modal-total-webquote-error"
        centered
        cla>
        <div className="box-generacion">
          <div className="box-generacion-header">
            <img
              src={No}
              alt="cerrar-modal"
              onClick={() => setTotalWebQuoteError(false)}
            />
          </div>
          <div className="box-generacion-body">
            <ExclamationTriangleFill className="total-web-quote-error-icon" />
            <p>{t('PRODUCTS_T.TOTAL_WEB_QUOTE_ERROR')}</p>
          </div>
        </div>
      </Modal>

      {/* MODAL PRINCIPAL VIEW CLIENT LIST */}
      <Modal
        show={showModalClient}
        className="modal-clase-choose-customer"
        backdrop={false}
        fullscreen={true}>
        <PrincipalModal
          handleShowModalClient={handleShowModalClient}
          handleModalAdd={handleModalAdd}
          setClienteCotizacion={setClienteCotizacion}
          resetAddressStatus={resetAddressStatus}
          setDefaultWarehouseToQuotation={setDefaultWarehouseToQuotation}
          onSuccessUpdateClient={handleSuccessUpdateClient}
        />
      </Modal>

      <ModalAlertCart preQuote={false} shopping={true} saleProduct={false} />

      {/* MODAL CONFIRM DELETE CLIENT */}
      <Modal show={showModalDeleteClient} centered>
        <EliminarCliente
          setShowModalDeleteClient={() => setShowModalDeleteClient(false)}
          handleConfirmDeleteClient={handleModalDelete}
        />
      </Modal>

      <div
        className={
          modalInfoClient || showCreditAccounts ? 'moda-background' : ''
        }>
        {showCreditAccounts && (
          <CreditAccountsModal
            customerId={customerId}
            setShowCreditAccounts={setShowCreditAccounts}
          />
        )}
        <CustomerInfo
          inModal={true}
          showCreditAccounts={showCreditAccounts}
          setShowCreditAccounts={setShowCreditAccounts}
          handleOpen={setModalInfoClient}
          open={modalInfoClient}
          customerId={customerId}
          setCustomerId={clienteMetodoEntrega?.CustomerID}
        />
      </div>

      {/* MODAL SUCCESS ADD CLIENT */}
      <Modal show={showModalAddClient}>
        <AgregarCliente handleModalAdd={handleModalAdd} />
      </Modal>

      {/* EDIT CLIENT */}
      <Modal show={showModalEditClient}>
        <div className="modal-box-client">
          <div className="restore-container">
            <div className="modal-header-restore">
              <h2>{t('PRODUCTS_T.EDIT_CLIENT_LABEL')}</h2>
              <img
                src={No}
                alt="close"
                onClick={() => {
                  setShowModalEditClient(false)
                }}
              />
            </div>
            <CrearCliente
              handleClose={() => setShowModalEditClient(false)}
              onSuccessUpdate={handleSuccessUpdateClient}
            />
          </div>
        </div>
      </Modal>

      <Modal
        show={showModalCart}
        className="modal-clase-choose-customer"
        backdrop={false}
        fullscreen={true}
        data-testid="modal-full-cart-summary">
        <div
          className="modal-summary-content"
          data-testid="container-modal-summary">
          <div className="product-cart-full-summary">
            <h2>{`${t('PRODUCTS_T.PRODUCT_RESUME_TITLE')} (${
              cart.length
            })`}</h2>
            <img
              src={No}
              alt="close"
              style={{
                cursor: 'pointer',
              }}
              data-testid="btn-close-cart-summary"
              onClick={() => {
                setShowModalCart(false)
              }}
            />
          </div>
          <SummaryOrderCart isShoppingCart />
        </div>
      </Modal>
    </Container>
  )
}

export default ShoppingCart
